// Package Imports

import { useTranslate } from '@refinedev/core';
import { useState } from 'react';

// Project Imports

import RulesCreate from 'pages/rules/RulesCreate';
import RuleGroupsCreate from 'pages/ruleGroups/RuleGroupsCreate';
import usePermission from 'core/utils/usePermission';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import getRenderRuleGroupDeleteButton, {
  getFilterRules,
  getRenderCopyButton,
  getRenderRuleDeleteButton,
} from 'pages/rules/utils/getActionButton';
import GroupRuleListSubcomponent from 'pages/rules/groupRuleListSubcomponent';

const GroupRuleList = ({
  stateData,
  stateFunctionHandler,
  functionHandler,
  formData,
}) => {
  // prettier-ignore
  const {pageType,rulePlanDataObj,rulesDetails,ruleGroupList,id,rulesData,activeType,activePageType}=stateData
  // prettier-ignore
  const {setCopyModalRow,setCopyModalVisible,setIsCopyModalSubmitDisabled,setIsFilterModalVisible,setTempRuleGroupList,setReArrangeModalOpen,setRuleDetails,setActiveType,setActivePageType,setRuleGroupList,setId}=stateFunctionHandler
  const { deleteRuleAndRuleGroup, fetchData } = functionHandler;
  const { copyModalForm } = formData;
  const t = useTranslate();
  const checkPermission = usePermission();
  const { userDetails } = useTokenContext();
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [enabledDivWidth, setEnabledDivWidth] = useState(30); // Initial 30%
  const handleMouseMove = (event: MouseEvent) => {
    const newWidth = (event.clientX / window.innerWidth) * 100;
    if (newWidth > 20 && newWidth < 60) {
      setEnabledDivWidth(newWidth);
    }
  };
  const handleMouseUp = () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.body.style.userSelect = '';
  };
  const handleMouseDown = () => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.body.style.userSelect = 'none';
  };
  // prettier-ignore
  const renderRuleGroupDeleteButton=getRenderRuleGroupDeleteButton(deleteRuleAndRuleGroup,pageType,rulePlanDataObj,fetchData,checkPermission,userDetails,t)
  // prettier-ignore
  const renderRuleDeleteButton=getRenderRuleDeleteButton(deleteRuleAndRuleGroup,pageType,rulePlanDataObj,fetchData,checkPermission,userDetails,t)
  // prettier-ignore
  const renderCopyButton=getRenderCopyButton(setCopyModalRow,checkPermission,setCopyModalVisible,copyModalForm,setIsCopyModalSubmitDisabled,pageType)
  const handleOpenFilterModal = () => {
    setIsFilterModalVisible(true);
  };
  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    index: number
  ) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };
  const handleDrop = (
    e: React.DragEvent<HTMLDivElement>,
    dropIndex: number
  ) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === dropIndex) return;
    const updatedList = [...rulesDetails.rule_group_list];
    const [movedItem] = updatedList.splice(draggedIndex, 1);
    updatedList.splice(dropIndex, 0, movedItem);
    // Store the temporary reordered list
    setTempRuleGroupList(updatedList);
    setReArrangeModalOpen(true);
  };
  const toggleRuleGroup = (index) => {
    const updatedRuleGroupList = rulesDetails.rule_group_list.map(
      (groupItem, i) => {
        if (i === index) {
          return { ...groupItem, expanded: !groupItem.expanded };
        }
        return groupItem;
      }
    );
    setRuleDetails({ ...rulesDetails, rule_group_list: updatedRuleGroupList });
  };
  const handleSetActiveState = (type, pageTypee) => {
    setActiveType(type);
    setActivePageType(pageTypee);
  };
  // prettier-ignore
  const filterRules=getFilterRules(rulesDetails,setRuleGroupList,)

  return (
    <div className="flex mt-md">
      <GroupRuleListSubcomponent
        functionHandler={{
          renderRuleGroupDeleteButton,
          renderRuleDeleteButton,
          filterRules,
          handleSetActiveState,
          toggleRuleGroup,
          handleDrop,
          handleDragOver,
          handleDragStart,
          handleOpenFilterModal,
          renderCopyButton,
          checkPermission,
        }}
        stateData={{ enabledDivWidth, pageType, ruleGroupList, id }}
        stateFunctionHandler={{ setId }}
      />
      <div
        className="resizer bg-neutral-30 cursor-col-resize flex flex-col justify-center whitespace-nowrap text-xs mr-sm"
        onMouseDown={handleMouseDown}
        style={{ cursor: 'col-resize' }}
      >
        <svg
          height="40px"
          width="20px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
          xmlSpace="preserve"
        >
          <g transform="rotate(90, 256, 256)">
            <polygon
              style={{ fill: 'var(--neutral-900)' }}
              points="300.138,194.207 397.241,194.207 256,0 114.759,194.207 211.862,194.207 211.862,317.793 
              114.759,317.793 256,512 397.241,317.793 300.138,317.793 	"
            />
          </g>
        </svg>
      </div>
      <div
        key={id}
        className="enabled2div h-[950px] overflow-y-scroll"
        style={{ width: `${100 - enabledDivWidth}%` }}
      >
        {activeType === 'rule' ? (
          <RulesCreate id={id} type={activePageType} />
        ) : null}
        {activeType === 'group' ? (
          <RuleGroupsCreate
            id={id}
            type={activePageType}
            rulesData={rulesData}
          />
        ) : null}
      </div>
    </div>
  );
};

export default GroupRuleList;
